import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var accordionThemeNative = {
  backgroundColor: colors.lightGrey,
  borderColor: colors.cloudGrey,
  fontColor: 'text'
};
var accordionDarkThemeNative = {
  backgroundColor: colors.mineShaftGrey,
  borderColor: colors.octoberGrey,
  fontColor: 'text'
};
var accordionThemeWeb = {
  /**
   * Background color of the button and the opened container element
   */
  backgroundColor: colors.lightGrey,
  borders: {
    active: 'primary',
    inactive: colors.cloudGrey,
    radius: 'borders.radius'
  },

  /**
   * Text and chevron color for plain accordion
   */
  plainColor: 'secondary',

  /**
   * Text and chevron color for normal accordion
   */
  fontColor: 'text'
};

var accordionDarkThemeWeb = _extends({}, accordionThemeWeb, {
  backgroundColor: colors.mineShaftGrey,
  borders: _extends({}, accordionThemeWeb.borders, {
    inactive: colors.inkGrey
  })
});

export { accordionDarkThemeNative, accordionDarkThemeWeb, accordionThemeNative, accordionThemeWeb };